import cartItemsAdapter from "@/redux/slice/cart/adapter/cartItem";
import { ThunkResolvedStatus } from "@/libs/enum/ThunkResolvedStatus";
import { CartState } from "@/redux/slice/cart/types/CartState";

const initialCartItems = cartItemsAdapter.getInitialState();

const initialState: CartState = {
  fetchingCart: ThunkResolvedStatus.idle,
  updatingCart: ThunkResolvedStatus.idle,
  cartFetchingUpdating: ThunkResolvedStatus.idle,
  cartItems: initialCartItems,
  isCartUpdated: false,
  userActionPayload: null,
  serverCartErrorMessage: "",
  cartLocation: {
    pincode: "",
    lat: 0,
    lng: 0,
  },
  allowFetch: false,
  allowServerUpdate: true,
  outOfStockSkuList: [],
};

export default initialState;
